import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2, ArrowRight } from 'lucide-react';
import api from '../../utils/api';

const VerifyEmail = () => {
  const { id, hash } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verify = async () => {
      try {
        const response = await api.get(`/email/verify/${id}/${hash}${window.location.search}`);
        if (response.data.success) {
          setStatus('success');
          setMessage(response.data.message);
        } else {
          setStatus('error');
          setMessage(response.data.message || 'Doğrulama işlemi başarısız oldu.');
        }
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.message || 'Geçersiz veya süresi dolmuş doğrulama bağlantısı.');
      }
    };

    if (id && hash) {
      verify();
    } else {
      setStatus('error');
      setMessage('Geçersiz doğrulama bağlantısı.');
    }
  }, [id, hash]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-800 dark:from-gray-900 dark:via-gray-800 dark:to-blue-900 flex items-center justify-center p-4 relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-white dark:bg-blue-500 opacity-10 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-white dark:bg-blue-500 opacity-10 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-md w-full relative z-10">
        <div className="bg-white/95 dark:bg-gray-800/95 backdrop-blur-lg rounded-2xl shadow-2xl p-8 border border-white/20 dark:border-gray-700">
          <div className="text-center space-y-6">
            {status === 'verifying' && (
              <>
                <div className="flex justify-center">
                  <Loader2 size={48} className="text-blue-600 dark:text-blue-400 animate-spin" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white">E-posta Doğrulanıyor</h2>
                <p className="text-gray-600 dark:text-gray-400">Lütfen bekleyin, e-posta adresiniz doğrulanıyor...</p>
              </>
            )}

            {status === 'success' && (
              <>
                <div className="flex justify-center">
                  <div className="bg-green-100 dark:bg-green-900/30 p-3 rounded-full">
                    <CheckCircle size={48} className="text-green-600 dark:text-green-400" />
                  </div>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Doğrulama Başarılı!</h2>
                <p className="text-gray-700 dark:text-gray-300 font-medium">
                  {message}
                </p>
                <Link
                  to="/login"
                  className="w-full inline-flex items-center justify-center bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold py-3 px-4 rounded-xl hover:from-blue-700 hover:to-indigo-700 transition-all shadow-lg"
                >
                  Giriş Yap
                  <ArrowRight size={18} className="ml-2" />
                </Link>
              </>
            )}

            {status === 'error' && (
              <>
                <div className="flex justify-center">
                  <div className="bg-red-100 dark:bg-red-900/30 p-3 rounded-full">
                    <XCircle size={48} className="text-red-600 dark:text-red-400" />
                  </div>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Doğrulama Hatası</h2>
                <p className="text-red-600 dark:text-red-400 font-medium">
                  {message}
                </p>
                <div className="pt-4 space-y-3">
                  <Link
                    to="/login"
                    className="w-full inline-flex items-center justify-center bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-200 font-semibold py-3 px-4 rounded-xl border border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600 transition-all"
                  >
                    Giriş Sayfasına Dön
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
